import { formFieldValue, formSelectorValues } from '../selectors/formFieldValue';

export const getAdditionalFormField = function (form, fieldName) {
  const selector = `input[name="${fieldName}"]:checked, select[name="${fieldName}"],\
   input[name="${fieldName}"]:not([type="radio"]):not([type="checkbox"]),\
   textarea[name="${fieldName}"]`;
  const values = formSelectorValues(form, selector);
  if (values.length) return values.join();
};

/**
 * Wizard leadform answers used by Sales and BI
 * This function creates a hash of all the wizard answers
 *
 * @param {element} form Form currently being validated
 * @returns {hash} hash of Wizard panel ids (keys) and user's answers (values)
 */
export const getAdditionalFormFields = function (form) {
  const fieldNames = formFieldValue(form, 'spells', '').split(',');
  const fields = fieldNames.reduce((memo, fieldName) => {
    const value = getAdditionalFormField(form, fieldName);
    if (value !== undefined && value !== '') memo[fieldName] = value;
    return memo;
  }, {});

  // 'extra' is a hidden string field containing any extra properties defined in the YML
  const extra = formFieldValue(form, 'extra');
  if(extra) { fields['extra'] = extra; }

  return fields;
};

/**
 * Sales requires the answers in the contacts.message field as a string
 *
 * @param {hash} additionalFormFields Hash of form fields
 * @returns {string} string of Wizard answers like "panel-name: answer | panel-name: answer | ..."
 */
export const additionalFormFieldsAsString = function (additionalFormFields) {
  let array = [];
  const { extra, ...fields } = additionalFormFields;
  for (let key in fields) {
    array.push(`${key}: ${additionalFormFields[key]}`);
  }

  // the "extra" field is already formatted the way we want, so push it to the end
  if(extra) { array.push(extra); }
  return array.join(' | ');
};

/**
 * BI requires the answers as a hash at root level as there is currently no support
 * for nested hashes in the 'anything goes' params
 *
 * @param {hash} additionalFormFields Hash of form fields
 * @returns {string} hash of Wizard answers like { "lead_form.panel_name": "answer", ... }
 */
export const additionalFormFieldsAsHash = function (additionalFormFields) {
  let hash = {};
  for (let key in additionalFormFields) {
    let transformedKey = `lead_form.${key.replace('-', '_')}`;
    hash[transformedKey] = additionalFormFields[key];
  }
  return hash;
};
